import React, { createContext, useContext, useEffect, useState } from 'react';
import './global.css';

const ThemeContext = createContext({ theme: 'light', setTheme: () => { } });

export function ThemeProvider({ children, defaultTheme = 'light' }) {
    const [theme, setTheme] = useState(defaultTheme);
    useEffect(() => { document.documentElement.setAttribute('data-theme', theme); }, [theme]);
    return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
export default ThemeProvider;
